import { CalendarCell, CalendarCellProps } from "@progress/kendo-react-dateinputs";
import { FC } from "react";

interface CustomCalendarCellProps extends CalendarCellProps {
  isHoliday?: boolean;
}

const CustomCalendarCell: FC<CustomCalendarCellProps> = (props) => {
  const { value, isHoliday, min, max, ...others } = props;
  const isWeekend = value.getDay() === 0 || value.getDay() === 6;
  const isDisabled = isWeekend || isHoliday || (min && value < min) || (max && value > max);

  const handleClick = (date: Date, event?: React.MouseEvent) => {
    if (!isDisabled) {
      props.onClick(date, event);
    }
  };

  return (
    <CalendarCell
      {...others}
      value={value}
      onClick={handleClick}
      className={isDisabled ? "k-disabled" : ""}
    />
  );
};

export { CustomCalendarCell };
